import React, { useState,useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import getDt from "../../utils";
import { showLoader } from "../redux/ctrl/ctrlActions";
import { updTagAct, refreshTagStatus } from "../redux/project/projActions";
import Select from "react-select";
import "./pkgSel.scss";
import { useEffect } from "react";
import COLORS from "../styles/COLORS";

const MultiTagComboStyle = {
    control: (base, state) => ({
      ...base,
      //background: "#fff",
      background: 'transparent',
      borderColor: 'transparent',
      marginTop: '-2px',
      width: 'auto',
      //opacity: 1,
      // match with the menu
      borderRadius: 0,
      // Overwrittes the different states of border
      // Removes weird border around container
      boxShadow: null,
      '&:hover': {
        borderColor: 'transparent',
        background: 'transparent',
      },
      //height: '20px',
      //'min-height': '20px',
       //width: '100px',
    }),
    menu: base => ({
      ...base,
      // override border radius to match the box
      borderRadius: 0,
      // beautify the word cut by adding a dash see https://caniuse.com/#search=hyphens for the compatibility
      hyphens: "auto",
      // kill the gap
      marginTop: '-10px',
      //innerHeight: '5px',
      textAlign: "left",
      // prevent menu to scroll y
      wordWrap: "break-word",
    }),
    menuList: base => ({
      ...base,
      // kill the white space on first and last option
      padding: 0
  
    }),
    valueContainer: (base) => ({
      ...base,
      padding: '0px 12px',
      paddingBottom: '6px'
    }),
    dropdownIndicator: provided => ({
      ...provided,
      paddingTop: 0,
      paddingBottom: '4px', 
      color: "hsl(0,0%,60%)"
    }),
    indicatorsContainer: (styles) => ({
       ...styles,
    }),
    indicatorSeparator: (styles) => ({
       ...styles,
       display: 'none'
    }),
    clearIndicator: (styles) => ({
        ...styles,
        marginBottom: 0,
       // marginTop: '-2px'
    }),
    singleValue : (style) => ({
       ...style,
       paddingBottom: '0.2pc'
    }),
    multiValue: (styles) => ({
      ...styles,
      marginBottom:'8px'
    }),
    multiValueLabel: (styles) => ({
      ...styles,
      padding: '2px'
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      paddingLeft: '2px',
      paddingRight: '2px'
    }),
    menuPortal: (base) => ({ 
      ...base, 
      zIndex: 9999 
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? COLORS.green : 'inherit',
      '&:hover': { backgroundColor: state.isSelected ? COLORS.green : '#e1fcf5' }
    }),    
  };
 
function TagStatus  (props) {
  const active_revision=useSelector((state)=>state.ctrl.pkg.active_revision)
  const slctRev  = props?.colDef?.cellRendererParams?.slctRev?.value || active_revision
  const writeAcc=props?.colDef?.cellRendererParams?.writeAcc  || true
  let getTagstat = useSelector((state) => state.ctrl.tagStatus);
  const prof = useSelector(state => state.profile)
  const dispatch = useDispatch();
  const pkg = useSelector((state) => state.ctrl.pkg);
  //let updA = false;
  //const SINP = useCallback( HOC(SelectInput,updA),[updA]);
  const profile = useSelector((state) => state.profile);
  const uptag= useSelector(state => state.prjasn.projectsAsn);
  const ctrlState = useSelector((state) => state.ctrl);
  const[writeAcc2,setWriteAcc2]=useState();
  
   
       useEffect(() => {
           let write_accsNew = uptag.filter((item) => item.project_id === ctrlState.data?.project_id && profile.email===item.email_id)[0]?.write_access
           write_accsNew =  ctrlState.data.created_by==profile.email || write_accsNew=='Y' ?true:false
           setWriteAcc2(write_accsNew)
       },[uptag,ctrlState.data]);

  const onChange = (event, props) => {
    const pl = props.data;
   pl[props.column.colDef.field] = event.value;
    pl["last_updatedby"] = prof.email;
    pl["last_updatedate"] = getDt(new Date());
    pl["creation_date"] =props.data.creation_date;// getDt(new Date());
    pl["selected"] = "Y";
    //pl['start_date']=getDt(new Date(props.data.start_date));
    pl['start_date']=null;
    dispatch(showLoader(true));
    dispatch(refreshTagStatus());
    dispatch(updTagAct(pl));
    dispatch(showLoader(false));
  };



  return (
    <div  style={{marginLeft: '-1pc',height:'100%'}}>
      <Select 
        styles={MultiTagComboStyle}
        menuPortalTarget={document.body}
        name="tagStatus"
        options={getTagstat} 
        isDisabled={(slctRev != active_revision ? true : false) || (prof.capb.findIndex((o) => o.PWSUPTAG === 'Y')>=0 ? false: true)|| (!writeAcc2)}
        placeholder="Div.."
        onChange={(event) => onChange(event,props)}   
        defaultValue = {{value:props?.data?.tag_line_status,label:getTagstat?.find(i=>i?.value === props?.data?.tag_line_status )?.label}}     
      />       
    </div>
  );
}

export default TagStatus;
